__turbopack_context__.v({
  "active": "CreatorCard-module-scss-module__yKcs2a__active",
  "creatorCard": "CreatorCard-module-scss-module__yKcs2a__creatorCard",
  "crown": "CreatorCard-module-scss-module__yKcs2a__crown",
  "delta": "CreatorCard-module-scss-module__yKcs2a__delta",
  "wrapper": "CreatorCard-module-scss-module__yKcs2a__wrapper",
});
